
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pam/vault",
      function () {
        return require("private-next-pages/pam/vault.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pam/vault"])
      });
    }
  